/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import openPrintDialog from "@insite/client-framework/Common/Utilities/openPrintDialog";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductShareLink, { ProductShareLinkStyles } from "@insite/content-library/Components/ProductShareLink";
import { IconMemo } from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

export interface ProductDetailsShareLinkStyles {
    wrapper?: InjectableCss;
    link?: ProductShareLinkStyles;
}

export const shareLinkStyles: ProductDetailsShareLinkStyles = {
    wrapper: {
        css: css`
            margin-top: 30px;
            text-align: center;
        `,
    },
};

const styles = shareLinkStyles;

const ProductDetailsShareLink: React.FC<Props> = ({ product, variantSelectionCompleted }) => { // xng-change
    const [isCopied, setIsCopies] = useState(false); // xng-change

    const copyLinkClickHandler = () => { // xng-change
        let url = window.location.href.split(/[?#]/)[0];
        const el = document.createElement("textarea");

        if (variantSelectionCompleted) {
            url += `?option=${product.productNumber}`;
        }

        el.value = url;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);

        setIsCopies(true);

        setTimeout(() => {
            setIsCopies(false);
        }, 1000 * 2);
    };

    if (!product) {
        return null;
    }

    // xng-change: adding two other links
    return (
        <StyledWrapper {...styles.wrapper}>
            <ProductShareLink text={translate("Email")} extendedStyles={styles.link} />
            <Link {...(styles as any).printClickable} onClick={openPrintDialog}>
                {translate("Print")}
                <IconMemo {...(styles as any).printIcon} />
            </Link>
            <Link {...(styles as any).copyLinkClickable} onClick={copyLinkClickHandler}>
                {isCopied && translate("Copied!")}
                {!isCopied && translate("Copy Link")}
                <IconMemo {...(styles as any).printIcon} />
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsShareLink)),
    definition: {
        displayName: "Share Link",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
